import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgShield = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		"data-name": "Layer 2",
		fill: "var(--main-color)",
		children: /* @__PURE__ */ _jsxs("g", {
			"data-name": "shield",
			children: [/* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 24,
				opacity: 0
			}), /* @__PURE__ */ _jsx("path", { d: "M12 21.85a2 2 0 0 1-1-.25l-.3-.17A15.17 15.17 0 0 1 3 8.23v-.14a2 2 0 0 1 1-1.75l7-3.94a2 2 0 0 1 2 0l7 3.94a2 2 0 0 1 1 1.75v.14a15.17 15.17 0 0 1-7.72 13.2l-.3.17a2 2 0 0 1-.98.25zm0-17.7L5 8.09v.14a13.15 13.15 0 0 0 6.7 11.45l.3.17.3-.17A13.15 13.15 0 0 0 19 8.23v-.14z" })]
		})
	})
});
export { SvgShield as ReactComponent };
